<template>
  <b-modal
    :title=title
    ref="news-search-modal"
    id="news-search-modal"
    size="lg"
    hide-footer
  >
    <section>    
      <link rel="stylesheet" type="text/css" :href=news_href>
      <b-card ref="nscPrintArea1" class="mb-1" style="font-family: NanumBarunGothic; padding: 0.3rem 1.5rem 1.0rem 1.5rem;" no-body>
        <b-row style="margin-top: 20px;">
          <b-col cols="12" style="text-align:center;">
            <h2>검색량 변동성 TOP 10 키워드</h2>
          </b-col>
        </b-row>
        <b-row id="nscColChart" style="margin-top: 5px; display: none;">
          <b-col cols="12">
            <div id="colChart">
              <news-column-chart
                :colChartData="chartData"
                :chartCategories="chartCategories"
                :baseKeyword="baseKeyword"
                :isChartInit="chartInit"
              />
            </div>
          </b-col>
          <b-col cols="12" style="margin-top: -10px; text-align:right;">
            <p style="margin-bottom: 0px; font-family: NanumBarunGothic !important; font-size: 10px; color: #FF009C;">※ 변동성 TOP 10 항목 중, 일정 변화량 이상인 항목만 출력하기 때문에 검색량 합계가 TOTAL과 상이할 수 있습니다.</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" style="margin-top: 5px;">
            <b-table
              class="keywordsTable position-relative"
              :items="tableData"
              :fields="tableColumns"
              :sort-desc.sync="sortDesc" 
              :sort-by.sync="sortBy"
              :sort-direction='sortDirection'
              :busy="isBusy"
              responsive
              show-empty
              no-border-collapse
              outlined
              hover
              table-class="table-font-size"
              empty-text="해당하는 키워드가 없습니다."
              sticky-header="true"
              style="max-height: 179px;"
              @row-clicked="onRowClicked"
            >
              <template #head()="{ label, field: { key, sortable } }">
                {{ label }}
                <template v-if="sortable">
                  <b-img v-if="sortBy !== key" src="/caretupdown.png" style="width: 10px;"></b-img>
                  <b-img v-else-if="sortDesc" src="/caretup.png" style="width: 9px;"></b-img>
                  <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                </template>
              </template>
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>분석중...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card>
      <b-card ref="nscPrintArea2" class="mb-1" style="font-family: NanumBarunGothic; padding: 0.3rem 1.5rem 1.0rem 1.5rem;" no-body>
        <b-row style="margin-top: 20px;">
          <b-col cols="3">
            <b-button
              v-if="hasSuperAdminRole()"
              size="sm"
              style="color: #fff; font-size: 11px; background-color: steelblue !important; border-color: lightsteelblue !important; box-shadow: none;"
              @click="runNewsAnalysis"
              :disabled="agentStatus!=='ready'"
            >
             ✨ AI 뉴스 분석
            </b-button>
          </b-col>
          <b-col cols="6" style="text-align:center;">
            <h2>관련 뉴스</h2>
          </b-col>
          <b-col class="d-flex align-items-center justify-content-end" cols="3">
            <h6 >기간 : <b>{{period}}</b></h6>
          </b-col>
        </b-row>
        <b-row id="loading_news" style="margin: 10px; visibility: visible;">
          <div class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>검색중...</strong>
          </div>
        </b-row>
        <b-row id="nscNewsAnalysis" style="margin: 5px 0 0 0; display: none;" class="copy-container" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
          <div class="news-anal-box align-items-center">             
            <div v-if="agentStatus==='analysing'" class="news-anal-row justify-content-center">
              <span class="news-anal-tdot"></span><span class="news-anal-tdot"></span><span class="news-anal-tdot"></span>
            </div>
            <div 
              v-for="(line, index) in parseLines(newsAnalysisData)" 
              :key="index"
            >
              <br v-if="line.newline" />
              <div 
                v-html="convertedHTML(line.text)"
                :style="{ paddingLeft: `${line.indent * 4}px` }"
              />
            </div>
          </div>
          <transition name="fade">
            <button
              v-show="isHovered"
              class="copy-btn"
              @click="copyToClipboard()"
            >
              <i v-if="!copied" class="ti ti-copy" />
              <i v-else class="ti ti-check"/>
            </button>
          </transition>
        </b-row>
        <b-row>
          <b-col>
            <div v-if="news_html != 'empty'">
              <p v-html="news_html"></p>
            </div>
            <div v-else>
              <h4 style="margin-top: 30px; margin-bottom: 30px; text-align:center; color: #FF009C">해당 기간동안 뉴스가 존재하지 않습니다.</h4>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </section>
  </b-modal>
</template>

<script>
import { 
  BCard, 
  BCol, 
  BRow, 
  BCardBody, 
  BButton,
  BCardText,
  BFormRadio, 
  BTable, 
  BPagination,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BTooltip,
  BImg,
} from "bootstrap-vue";

import axios from "axios"
import moment from "moment";
import useJwt from "@/auth/jwt/useJwt";

import ToastificationContent from "@core/components/toastification/ToastificationContent";

import CisKeywordsearchService from "@/services/cis-keywordsearch.service";
import AiAgentService from "@/services/cis-aiagent.service";
import CategoryService from "@/services/category.service";

import NewsColumnChart from "@/views/cis-keywordsearch/components/NewsSearchChartColumn.vue";

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default {
  name: "NewsSearchModal",
  components: {
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BImg,

    NewsColumnChart
  },
  props: {
  },
  data() {
    return {
      title: '검색 키워드 - ',
      period: "",
      st_dt: "",
      en_dt: "",

      newsCnt: 0,
      newss: [],

      news_html: "",
      news_href: "",

      chartInit: false,
      chartCategories: [],
      chartData: [],

      isBusy: false,
      tableData: null,
      tableColumns: [
        { key: 'keyword', label: '키워드', sortable: true , thClass: 'text-center', tdClass: 'text-center'},
        { key: 'diffFreq', label: '변화량', sortable: true , thClass: 'text-center', tdClass: 'text-right'},
        { key: 'lastFreq', label: '지난주', sortable: true , thClass: 'text-center', tdClass: 'text-right'},
        { key: 'thisFreq', label: '이번주', sortable: true , thClass: 'text-center', tdClass: 'text-right'},
      ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'desc',

      baseKeyword: "",

      user_id : "",
      sess_id : "",

      agentStatus: "ready",

      searchKeyword: "",
      newsLink: [],
      newsAnalysisData: "",

      // for clipboard
      copied: false,
      isHovered: false
    };
  },
  computed: {
  },
  watch: {
    sortDesc(val) {
      if(val)
        this.sortBy = null
    },
  },
  methods: {
    bindingChartSeries(data) {
      const chartSeries = [];
      
      for (const item of data) {
        chartSeries.push(
          {
            name: item.name,
            data: item.data,
          }
        )
      }

      return chartSeries;
    },

    async loadData(keyword, st_dt, en_dt, data, isHideChart) {
      console.log("----- loadData -----")

      if(document.getElementById('loading_news'))
        document.getElementById('loading_news').style.visibility = "visible";

      var max_dsp_items = 10;

      this.st_dt = st_dt
      this.en_dt = en_dt

      this.isBusy = true
      this.news_html = ""
      this.tableData = [];

      this.baseKeyword = keyword.replace(/(\s*)/g, "")

      if (data.length > 0) {
        this.chartInit = false;
        this.chartCategories = [];
        this.chartData = [];

        var item_cnt = 0;
        var curr_tot = 0;
        var prev_tot = 0;
        var diff_tot = 0;
        var curr_data = []
        var prev_data = []
        var diff_data = []

        // 변화량 총합계 계산
        for (let i = 0; i < data.length; i++) {
          const item = data[i];

          prev_tot += Number(item.lastFreq.replace(',', ''));
          curr_tot += Number(item.thisFreq.replace(',', ''));
          diff_tot += Number(item.diffFreq.replace(',', ''));
        }

        for (let i = 0; i < data.length; i++) {
          const item = data[i];

          if (!isHideChart && Number(item.diffFreq.replace(',', '')) < diff_tot * 0.05) // 변화량이 5% 미만인 경우 제외
            continue;

          this.tableData.push(item);

          item_cnt += 1;

          this.chartCategories.push(item.keyword);

          prev_data.push(Number(item.lastFreq.replace(',', '')));
          curr_data.push(Number(item.thisFreq.replace(',', '')));
          diff_data.push(Number(item.diffFreq.replace(',', '')));

          if (max_dsp_items <= item_cnt)
            break;
        }

        this.chartCategories.unshift('TOTAL')

        prev_data.unshift(prev_tot);
        curr_data.unshift(curr_tot);
        diff_data.unshift(diff_tot);

        this.chartData = this.bindingChartSeries([
          {
            name: '변화량',
            data: diff_data
          },
          {
            name: '지난주',
            data: prev_data
          },
          {
            name: '이번주',
            data: curr_data
          }
        ])      

        this.chartInit = true;
      }
      
      this.isBusy = false;

      if (this.chartCategories.length > 1)
        await this.getNewsData(this.chartCategories[1]);
      else
        await this.getNewsData(this.baseKeyword);

      if (!isHideChart) {
        if(document.getElementById('nscColChart'))
          document.getElementById('nscColChart').style.display = "block";
      }  
    },

    async getNewsData(keyword) {
      var st_dt_str = moment(this.st_dt).format("YYYY.MM.DD")
      var en_dt_str = moment(this.en_dt).format("YYYY.MM.DD")

      this.title = '검색 키워드 정보 - ' + keyword
      this.period = st_dt_str + ' ~ ' + en_dt_str
      this.searchKeyword = keyword

      const response_contents = await CisKeywordsearchService.getNewsData({
        searchKeyword : keyword,
        st_dt: this.st_dt,
        en_dt: this.en_dt
      });

      if (response_contents && response_contents.status === 200) {
        console.log('----- contents data -----')
        console.log(response_contents)

        if (response_contents.data.data.news == null || response_contents.data.data.news.length == 0)
          this.news_html = "empty"
        else {
          this.news_html = await this.parseHTML(response_contents.data.data.news)
          this.news_href = "https://ssl.pstatic.net/sstatic/fe/fender/client/" + response_contents.data.data.uid + "/index.css"
        }
      }

      document.getElementById('loading_news').style.visibility = "hidden";
    },

    async onRowClicked(item, index, event) {
      await this.getNewsData(item.keyword);
    },

    find_all(html, options = {}) {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const { tag = '*', className, attr, text } = options;

      // 셀렉터 조합
      let selector = tag;
      if (className) selector += `.${className}`;
      if (attr)      selector += `[${attr.name}="${attr.value}"]`;

      const elements = [...doc.querySelectorAll(selector)];

      // 텍스트 필터링 (BeautifulSoup string= 과 동일)
      if (text) {
        return elements.filter(el => el.textContent.trim() === text);
      }

      return elements;
    },

    del_all(html, options = {}) {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const { tag = '*', className, attr, text } = options;

      // 셀렉터 조합
      let selector = tag;
      if (className) selector += `.${className}`;
      if (attr)      selector += `[${attr.name}="${attr.value}"]`;

      const elements = [...doc.querySelectorAll(selector)];

      // 텍스트 필터링 (BeautifulSoup string= 과 동일)
      if (text) {
        const target_el = elements.filter(el => el.textContent.trim() === text);

        if (target_el[0].parentNode.parentNode.parentNode.parentNode.nextSibling)
          target_el[0].parentNode.parentNode.parentNode.parentNode.nextSibling.remove();

        target_el[0].parentNode.parentNode.parentNode.parentNode.remove();
      }
      else {
        if (elements[0].parentNode.parentNode.parentNode.parentNode.nextSibling)
          elements[0].parentNode.parentNode.parentNode.parentNode.nextSibling.remove();

        elements[0].parentNode.parentNode.parentNode.parentNode.remove();
      }

      return doc.body.innerHTML;
    },

    async newsFiltering(headlines) {
      var cat_nm = ""
      var cat_schema = ""
      var articles = []

      const cat_resp = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, source);

      if (cat_resp.data.success) {
        cat_nm = cat_resp.data.data.title
        cat_schema = cat_resp.data.data.cd
      }

      for (const item of headlines) {      
        articles.push(
          {
            "title": item.parentNode.textContent, 
            "description": item.parentNode.nextSibling.textContent,
            "link": item.parentNode.href,
            "body": "",
            "press": "",
            "pub_date": "",
          }
        )
      }
     
      // 뉴스 분석 Agent 호출
      const news_filter_resp = await AiAgentService.callAiAgent_NewsFiltering(
      {
        "db_schema" : cat_schema,
        "cat_name": cat_nm, 
        "search_keyword": this.searchKeyword,
        "articles": articles
      }, source)

      if (news_filter_resp && news_filter_resp.status == 200 && news_filter_resp.data.data != null)
        return news_filter_resp.data.data

      return null
    },
    
    async parseHTML(html) {
      this.newsLink = []

      const headlines = this.find_all(html, {tag: 'span', className: 'sds-comps-text-type-headline1'})

      if (this.hasSuperAdminRole()) {
        var idx = 0
        var tmp_html = html
        var filter_result = await this.newsFiltering(headlines)
        
        for (const decision of filter_result.decisions) {
          if (decision == "relevant")
            this.newsLink.push(filter_result.articles[idx].link)
          else
            tmp_html = this.del_all(tmp_html, {tag: 'span', className: 'sds-comps-text-type-headline1', text: filter_result.articles[idx].title.replace("새 창 열림", "")})

          idx += 1
        }

        const filterd_headlines = this.find_all(tmp_html, {tag: 'span', className: 'sds-comps-text-type-headline1'})

        if (filterd_headlines.length == 0) 
          return "empty"

        return tmp_html
      }
      else {
        for (const item of headlines)
          this.newsLink.push(item.parentNode.href)

        return html
      }
    },

    async runNewsAnalysis() {
      if (this.newsAnalysisData.length > 0)
        this.newsAnalysisData = ""

      var st_dt = moment(this.st_dt).format("YYYY.MM.DD")
      var en_dt = moment(this.en_dt).format("YYYY.MM.DD")

      if (this.newsLink.length <= 0) // 분석할 뉴스가 없는 경우 Pass
        return "" 

      if(document.getElementById('nscNewsAnalysis')) 
      {
        document.getElementById('nscNewsAnalysis').style.display = "block";
        this.agentStatus = "analysing"
      }
      
      var cnt = 1
      var news_ref_str = ``
      
      for (const item of this.newsLink) {
        news_ref_str += `${cnt++}) ${item}\n `
      }

      news_ref_str.trim().slice(0, -1) // 마지막 문자 제거

      const question = `- 검색 키워드 : ${this.searchKeyword}\n - 조회 기간 : ${st_dt} ~ ${en_dt}\n - 참조 URL 리스트 : \n${news_ref_str}`

      // 뉴스 분석 Agent 호출
      const response = await AiAgentService.callAiAgent_NewsSummary(
      {
        "session_id" : this.sess_id,
        "user_id": this.user_id, 
        "parts": [
          { "type": "text", "text": question }
        ],
        "dataset": {
          "path": "",
          "cat_id": "",
          "serv_nm": "",
          "col_st_dt": "",
          "col_en_dt": "",
          "major_list": []
        }
      }, source)

      console.log("----- AI Agent | News Summary  -----")
      console.log(response)

      this.agentStatus = "typing"

      if (response && response.status == 200 && response.data != null)
        this.typeWrite(response.data.data.response_text)
      else {
        if(document.getElementById('nscNewsAnalysis'))
          document.getElementById('nscNewsAnalysis').style.display = "none";
      }
    },

    typeWrite(text) {
      this.newsAnalysisData = ""

      if (text == null || text.length == 0)
        return

      let i = 0;

      const timer = setInterval(() => {
        this.newsAnalysisData += text[i++]

        if (i >= text.length) {
          clearInterval(timer)
          this.agentStatus = "ready"
        }
      }, 20)
    },

    parseLines(text) {
      if (!text) return [];

      return text
        .split('\n')
        .map(line => {
          const trimmed = line.trim();

          if (!trimmed) return null;

          if (/^[-*+]\s+/.test(trimmed)) {
            return {
              text: trimmed,
              indent: 2,
              newline: false,
            };
          }

          if (/^\d+\.\s+/.test(trimmed)) {
            return {
              text: trimmed,
              indent: 1,
              newline: false,
            };
          }

          const headingNumberMatch = trimmed.match(/^#{1,6}\s+(\d+)[\.\s]/);

          if (headingNumberMatch) {
            
            const num = parseInt(headingNumberMatch[1]);
            return {
              text: trimmed.replace(/^#{1,6}\s+/, ''),
              indent: 0,
              newline: num > 1, // 2 이상일 때만 줄띄어쓰기
            };
          }

          return {
            text: trimmed.replace(/^#{1,6}\s+/, '')
                        .replace(/^>\s+/, '')
                        .replace(/\*\*(.*?)\*\*/g, '$1')
                        .replace(/\*(.*?)\*/g, '$1')
                        .replace(/`(.*?)`/g, '$1')
                        .replace(/\[(.*?)\]\(.*?\)/g, '$1'),
            indent: 0,
          };
        })
        .filter(s => s);
    },

    convertedHTML(text) {
      return text
        .replace(/(\d+)\.\s*(.+)/g, '<b><h6 style="color: whitesmoke;">$1. $2</h6></b>')
        .replace(/\*\*(.*?)\*\*/g, '<u><strong>$1</strong></u>')  // **bold**
        .replace(/\*(.*?)\*/g, '<em>$1</em>')               // *italic*
        .replace(/`(.*?)`/g, '<code>$1</code>');            // `code`
    },

    async copyToClipboard() {
      try {
        if (this.newsAnalysisData.length == 0)
          throw new Error("AI 분석 결과 없음")

        await navigator.clipboard.writeText(this.newsAnalysisData)
        this.copied = true
        setTimeout(() => (this.copied = false), 2000)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Copy to clipboard successful`,
            icon: "EditIcon",
            variant: "success",
          },
        });
      } catch (err) {
        console.error('클립보드 복사 실패:', err)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Copy to clipboard failed`,
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
    }
  },

  created() {
    this.user_id = String(useJwt.getUserData().adacctId)
    this.sess_id = crypto.randomUUID()
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

#news-search-modal___BV_modal_title_
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
}

#news-search-modal .modal-body {
    padding: 0.8rem 0.8rem;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
}

.sds-comps-text {
    line-height: 1.8rem !important;
}

.sds-comps-text.sds-comps-text-type-headline1 {
  --sds-comps-text-font-size: 1.0rem !important;
  --sds-comps-text-letter-spacing: -0.3px;
  --sds-comps-text-line-height: 2.0rem;
}

.sds-comps-text.sds-comps-text-type-body1 {
  --sds-comps-text-font-size: 0.9rem !important;
  --sds-comps-text-letter-spacing: -0.3px;
  --sds-comps-text-line-height: 2.4rem;
}

.sds-comps-text.sds-comps-text-type-body2 {
  --sds-comps-text-font-size: 0.8rem !important;
  --sds-comps-text-letter-spacing: -0.3px;
  --sds-comps-text-line-height: 2.0rem;
}

.sds-comps-vertical-layout.sds-comps-full-layout {
  gap: 5px !important;
}

.keywordsTable .table.b-table > thead > tr > th,
.keywordsTable .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
}

.keywordsTable .table th,
.keywordsTable .table td {
  padding: 0.4rem 1.2rem;
}

.keywordsTable .table-font-size {
  font-size: 12px;
  font-weight: 600;
}

.news-anal-box {
  width: auto; 
  height: auto; 
  padding: 10px; 
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 30%, #0f3460 100%); 
  border-radius: 8px; 
  font-family: 'Pretendard', 'Noto Sans KR', sans-serif; 
  color: rgb(200, 200, 200); 
  font-size: 12px;
  line-height: 1.8;
}

.news-anal-row {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

.news-anal-tdot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(214, 228, 246, 1); 
  animation: bl 1.2s infinite;
  margin: 0 2px;
}
.news-anal-tdot:nth-child(2) {
  animation-delay: 0.2s;
}
.news-anal-tdot:nth-child(3) {
  animation-delay: 0.4s;
}

.copy-container {
  position: relative;  /* 플로팅 버튼의 기준점 */
  display: inline-block;
  width: 100%;
}

.copy-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  /* // padding: 2px 6px; */
  width: 24px;
  height: 24px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  /* // margin: 0; */
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.copy-btn:hover {
  background: rgba(0, 0, 0, 0.85);
}

/* 페이드 트랜지션 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


</style>